import HTTPClient from '../..'

export const deleteAlerts = async () => {
  await HTTPClient.delete('alerts')
}
